module.exports = __webpack_public_path__ + "static/img/aplicativo-web.1699079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/aplicativo-web.png
// module id = 7yEL
// module chunks = 0